'use client'

import { useTranslations } from 'next-intl'

import { Paragraph } from '@graftcode/design-system'

import { ONBOARDING_LOADER_TEST_IDS } from '@apps/onboarding/onboarding-test-ids.const'

import styles from './OnboardingLoader.module.scss'

export function OnboardingLoader() {
  const t = useTranslations('onboarding')

  return (
    <div className={styles.overlay} data-testid={ONBOARDING_LOADER_TEST_IDS.root}>
      <div className={styles.container}>
        <div className={styles.loader}>
          <div className={styles.spinner}></div>
        </div>

        <Paragraph size="sm" className={styles.message}>
          {t('loading')}
        </Paragraph>
      </div>
    </div>
  )
}
